"use strict";

module.exports = Object.freeze({
  INSPECT_ADMIN: 'INSPECT_ADMIN',
  INSPECT_INSPECTOR: 'INSPECT_INSPECTOR',
  INSPECT_MANAGER: 'INSPECT_MANAGER',
  INSPECT_ROUTING_GROUP_MANAGER: 'INSPECT_ROUTING_GROUP_MANAGER',
  INSPECT_SAFETY_COORDINATOR: 'INSPECT_SAFETY_COORDINATOR',
  INSPECT_SUPER_USER: 'INSPECT_SUPER_USER'
});